import Pickr from "@simonwep/pickr";
import $ from "jquery";
import {
  changeSceneTime,
  GetGroup,
  getSubsystemSummary,
  hideIcon,
  pergola,
  pergolaConst,
  showIcon,
} from "../../core/3d-configurator";
import { removeFromUrlSystemBySideAndtype } from "../../core/customFunctions/initiSubSystem";
import { state } from "../../core/settings";
import { deleteActiveClassFromContainerRadioType } from "../interface/interface";
import { updateTextParam } from "../interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
import { generateRangeHTML } from "../interface/interfaceItems/interfaceGroup/interfaceGroupInputs/range/generateRange";
import "./portals.scss";

export const lightRange = [
  {
    title: "Spacing",
    min: 2,
    max: 8,
    step: 1,
    thumb: true,
    initialValue: state.recessedLighting,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const shadesRange = [
  {
    title: "Shades",
    min: 1,
    labelMin: "0",
    max: 90,
    step: 1,
    thumb: false,
    initialValue: state.zipInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const bladeRotation = [
  {
    title: "Roof Settings",
    min: 1,
    labelMin: "0",
    max: 170,
    step: 1,
    thumb: false,
    initialValue: state.currentRotationZ,
    showLabels: true,
    showSwitchAngle: false,
  },
];


export const louversOpening = [
  {
    title: "louversRange",
    min: 0,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.louversOpeningInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];


export const slidingDoor = [
  {
    title: "Slide Glass Doors:",
    min: 0,
    labelMin: "Open",
    max: 97,
    labelMax: "Close",
    step: 1,
    thumb: false,
    initialValue: state.slidingDoorInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const slidingShutters = [
  {
    title: "Aluminum Sliding Shutters:",
    min: 0,
    labelMin: "Open",
    max: 100,
    labelMax: "Close",
    step: 1,
    thumb: false,
    initialValue: state.slidingShuttersInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const zipShadeRange = [
  {
    title: "Blinds and Shades:",
    min: 0,
    labelMin: "Open",
    max: 100,
    labelMax: "Close",
    step: 1,
    thumb: false,
    initialValue: state.zipInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldDoorRange = [
  {
    title: "bi-fold",
    min: 1,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const shuttersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 180,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.slidingShuttersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const fixShuttersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 180,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.slidingFixShuttersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldShatters = [
  {
    title: "Open",
    min: 1,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorShattersInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldShattersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 100,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorShattersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

function createHandleRange(
  compare,
  portalContainer,
  stateKey,
  inputSelector = ".range__input"
) {
  if (compare) {
    const $rangeInput = portalContainer.find(inputSelector);

    // ✅ INIT
    $rangeInput.val(state[stateKey]);

    const min = parseInt($rangeInput.attr("min"), 10);
    const max = parseInt($rangeInput.attr("max"), 10);
    const value = parseInt($rangeInput.val(), 10);

    // ✅ INIT BG
    const percentValue =
      Math.round(((value - min) / (max - min)) * 100 * 100) / 100;
    $rangeInput.css(
      "background",
      `linear-gradient(to right, #629A33 ${percentValue}%, #629A334D ${percentValue}%)`
    );

    // ✅ INIT thumb
    const $rangeThumbValue = portalContainer.find("#range__thumb-value");

    const borderForHide = 2;

    if ($rangeThumbValue) {
      if (
        (value >= min &&
          value <= min + borderForHide &&
          max - min > borderForHide * 2) ||
        (value >= max - borderForHide &&
          value <= max &&
          max - min > borderForHide * 2)
      ) {
        $rangeThumbValue.hide();
      } else {
        $rangeThumbValue.show();
        $rangeThumbValue.text(`${value}%`);

        const percent = ((value - min) / (max - min)) * 100;
        const thumbOffset = $rangeThumbValue.outerWidth();
        $rangeThumbValue.css("left", `calc(${percent}% - ${thumbOffset}px)`);
      }

      if (value === min || value === max) {
        $rangeThumbValue.hide();
      }
    }

    // ✅ HANDLE "input"
    $rangeInput.on("input", function (event) {
      if (state.roofType === 1 && state.portalOption === 10 && stateKey === "currentRotationZ" && Number(state.louversOpeningInput) > 0) {
        return;
      }
      const $rangeInput = $(this);
      state[stateKey] = +event.target.value;

      const min = parseInt($rangeInput.attr("min"), 10);
      const max = parseInt($rangeInput.attr("max"), 10);
      const value = parseInt($rangeInput.val(), 10);

      const percentValue =
        Math.round(((value - min) / (max - min)) * 100 * 100) / 100;

      $rangeInput.css(
        "background",
        `linear-gradient(to right, #629A33 ${percentValue}%, #629A334D ${percentValue}%)`
      );

      const $rangeThumbValue = portalContainer.find("#range__thumb-value");

      if ($rangeThumbValue) {
        if (
          (value >= min &&
            value <= min + borderForHide &&
            max - min > borderForHide * 2) ||
          (value >= max - borderForHide &&
            value <= max &&
            max - min > borderForHide * 2)
        ) {
          $rangeThumbValue.hide();
        } else {
          $rangeThumbValue.show();
          $rangeThumbValue.text(`${value}%`);

          const percent = ((value - min) / (max - min)) * 100;
          const thumbOffset = $rangeThumbValue.outerWidth() / 2;
          $rangeThumbValue.css("left", `calc(${percent}% - ${thumbOffset}px)`);
        }

        if (value === min || value === max) {
          $rangeThumbValue.hide();
        }
      }

      pergola.update();
    });
  }
}

function removeHandle(
  portalContainer,
  portalContentTitle,
  key,
  indexOfMenu,
  typeIndex
) {
  portalContainer.find(".portal-container__remove").on("click", function () {
    const moodLight = $(".type_interface_electronic")
      .find(".option")
      .eq(indexOfMenu);

    moodLight.removeClass("type_interface_electronic_item--active");

    state[key] = false;
    state.electro.delete(portalContentTitle);

    updateTextParam(state, moodLight, true);

    hideIcon(typeIndex);

    $(".portal-container").hide();

    state.currentActiveSystems = null;

    $(".interface-container").removeClass("interface-container-portal");

    pergola.update();
  });
}

function removeHandleSystem(
  portalContainer,
  portalContentTitle,
  key,
  indexOfMenu,
  typeIndex
) {
  portalContainer.find(".portal-container__remove").on("click", function () {
    const lastSpan = state.lastSpan;
    if (!lastSpan) return;

    pergola.removeSystemFromSpan(lastSpan);

    removeFromUrlSystemBySideAndtype(
      lastSpan.side,
      state.currentActiveSystems,
      lastSpan.number
    );

    if (!pergola.checkSystemInAllSpans(state.currentActiveSystems)) {
      hideIcon(typeIndex);
      $(".portal-container").hide();

      const subSystems = $(`#last-group #${typeIndex}`);

      subSystems.removeClass("type_interface_electronic_item--active");
      subSystems.find("input[type='radio']").prop("checked", false);

      state[key].delete(portalContentTitle);

      subSystems
        .closest(".interface__group")
        .find(".interface__group__head__param")
        .text(`${updateTextParam(state, this, true, true, true)}`);

      state.currentActiveSystems = null;
    } else {
      $(".portal-container__close").trigger("click");
    }

    $(".interface-container").removeClass("interface-container-portal");
    pergola.update();
  });
}

export const typePortalOption = {
  "LED Lights": "LED Lights",
  Heater: "Heater",
};

window.updateSlidingRangesMax = function () {
  const clampMax = 25;
  const xAxisSides = [pergolaConst.side.Front, pergolaConst.side.Back];
  const yAxisSides = [pergolaConst.side.Left, pergolaConst.side.Right];

  const shutterSides = getSubsystemSummary(pergolaConst.systemType.privacyWall);
  const doorSides = getSubsystemSummary(pergolaConst.systemType.slidingGlassDoor);

  const isNarrowShutter =
    (state.width === 1 && shutterSides.some(s => xAxisSides.includes(s))) ||
    (state.length === 1 && shutterSides.some(s => yAxisSides.includes(s)));
  const isNarrowDoor =
    (state.width === 1 && doorSides.some(s => xAxisSides.includes(s))) ||
    (state.length === 1 && doorSides.some(s => yAxisSides.includes(s)));

  // Always clamp state values when relevant dimension is minimum
  if (isNarrowShutter && state.slidingShuttersInput > clampMax) state.slidingShuttersInput = clampMax;
  if (isNarrowDoor && state.slidingDoorInput > clampMax) state.slidingDoorInput = clampMax;

  // Portal DOM update — only when portal is open
  const $portal = $("#content .portal-container");
  if (!$portal.length) return;

  const isDoorPortal = state.portalOption === pergolaConst.systemType.slidingGlassDoor;
  const isShutterPortal = state.portalOption === pergolaConst.systemType.privacyWall;
  if (!isDoorPortal && !isShutterPortal) return;

  const isNarrow = isDoorPortal ? isNarrowDoor : isNarrowShutter;
  const originalMax = isDoorPortal ? 97 : 100;
  const newMax = isNarrow ? clampMax : originalMax;

  const $rangeInput = $portal.find('.range__input');
  if (!$rangeInput.length) return;

  $rangeInput.attr('max', newMax);

  const stateKey = isDoorPortal ? 'slidingDoorInput' : 'slidingShuttersInput';
  if (state[stateKey] > newMax) {
    state[stateKey] = newMax;
    $rangeInput.val(newMax);
  }

  const value = parseInt($rangeInput.val(), 10);
  const min = parseInt($rangeInput.attr('min'), 10);
  $rangeInput.css('background', `linear-gradient(to right, #629A33 ${((value - min) / (newMax - min)) * 100}%, #629A334D ${((value - min) / (newMax - min)) * 100}%)`);
};

export function portalComponent() {
  $(document).off('click.colorBox').on('click.colorBox', '.colors_picker_color', function () {
    $(this).next().trigger('click');
  });

  const bladeRange = generateRangeHTML(bladeRotation[0]).html();
  const louversRange = generateRangeHTML(louversOpening[0]).html();
  const zipRange = generateRangeHTML(zipShadeRange[0]).html();
  const slidingDoorRange = generateRangeHTML(slidingDoor[0]).html();
  const slidingShuttersRange = generateRangeHTML(slidingShutters[0]).html();
  const biFoldRange = generateRangeHTML(biFoldDoorRange[0]).html();
  const shuttersRotateRange = generateRangeHTML(shuttersRotate[0]).html();
  const fixShuttersRotateRange = generateRangeHTML(fixShuttersRotate[0]).html();
  const biFoldShattersRange = generateRangeHTML(biFoldShatters[0]).html();
  const biFoldShattersRotateRange = generateRangeHTML(
    biFoldShattersRotate[0]
  ).html();

  const modelId = $("#ar_model_viewer");
  const mainContent = $("#content");

  function portalGenerete() {
    const existingPortal = mainContent.find(".portal-container");

    if (existingPortal.length > 0) {
      existingPortal.remove();
    }

    let portaInnerHtml = "";

    switch (state.portalOption) {
      case 7:
        portaInnerHtml = `
          <h3 class="portal-container__title">Mood Light</h3>
            <div class="type_interface_colors-buttons-led">
            <h3  class="portal-container__title__sub-title">Color</h3>
           
            <div class="type_interface_colors-buttons-led__options">
               <div class="type_interface_colors-buttons-led__item option">
                <label class="type_interface_colors-buttons-led__label">
                    <div class="image-container" style="background-color: #ffffff">
                    </div>
                    <span class="color-name">White</span>
                    <input class="type_interface_colors-buttons-led__option" type="radio" id="C34Bronze" name="fav_language" value="Oak">
                </label>
            </div>

            <div class="type_interface_colors-buttons-led__item option">
                <label class="type_interface_colors-buttons-led__label">
                    <div class="image-container" style="background-color: #FAFFC4">
                    </div>
                    <span class="color-name">Yellow</span>
                    <input class="type_interface_colors-buttons-led__option" type="radio" id="C34Bronze" name="fav_language" value="Oak">
                </label>
            </div>
            </div>
         
            <div class="colors_picker_container">
                <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorLed}">
                </div>
                
                <div class="colors_picker_button" id="color-picker">
                    Color Picker
                </div>
        
                <div id="color-picker-container"></div>
            </div>
        </div>

           

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case 6:
        portaInnerHtml = `
          <h3 class="portal-container__title">LED Lights</h3>
            <h3  class="portal-container__title__sub-title">Frequency</h3>

            <div class="main_container">
            <div class="text">Every</div>

            <ul class="radio__container">
              <li class="radio__container__item ">
                <div class="radio__container__item__cyrcle"></div>

                <span class="radio__container__item__text">3</span>
              </li>

              <li class="radio__container__item">
                <div class="radio__container__item__cyrcle"></div>

                <span class="radio__container__item__text">4</span>
              </li>

              <li class="radio__container__item">
                <div class="radio__container__item__cyrcle"></div>

                <span class="radio__container__item__text">5</span>
              </li>
            </ul>

            <div class="text">louvers</div>
            </div>
          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case pergolaConst.systemType.autoShade:
        portaInnerHtml = `
    <h3 class="portal-container__title">${pergolaConst.systemNameString.autoShade}</h3>

             <div class="portal-container__description">
                <span class="">Selected Color</span>
                <span class="colorShade">${state.colorZip}</span>
                </div>


          <div class="colors_picker_container">
              <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorZip}">
                </div>
                
                <div class="colors_picker_button" id="color-picker">
                    Pick the Color
                </div>
        
                <div id="color-picker-container"></div>
          </div>


          <div class="portal-container__range" id="zip-range_wrap">
          ${zipRange}
          </div>

         <span class="portal-container__remove">Remove</span>
        `;
        break;


      case pergolaConst.systemType.slidingGlassDoor:
        portaInnerHtml = `
    <h3 class="portal-container__title">${pergolaConst.systemNameString.slidingGlassDoor}</h3>

             <div class="portal-container__description">
                <span class="">Selected Color</span>
                <span class="colorShade">${state.colorSladditec}</span>
                </div>


          <div class="colors_picker_container">
              <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorSladditec}">
                </div>
                
                <div class="colors_picker_button ${state.portalOption === pergolaConst.systemType.slidingGlassDoor ? 'colors_picker_button--wide' : ''}" id="color-picker">
                    Pick Glass Frame Color
                </div>
        
                <div id="color-picker-container"></div>
          </div>


          <div class="portal-container__range" id="sliding-door-range_wrap">
          ${slidingDoorRange}
          </div>

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case pergolaConst.systemType.privacyWall:
        portaInnerHtml = `
    <h3 class="portal-container__title">${pergolaConst.systemNameString.privacyWall}</h3>

             <div class="portal-container__description">
                <span class="">Selected Color</span>
                <span class="colorShade">${state.colorShutters}</span>
                </div>


          <div class="colors_picker_container">
              <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorShutters}">
                </div>
                
                <div class="colors_picker_button" id="color-picker">
                    Pick the Color
                </div>
        
                <div id="color-picker-container"></div>
          </div>


          <div class="portal-container__range" id="zip-range_wrap">
          ${slidingShuttersRange}
          </div>

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case 10:
        const isBladeBlocked = Number(state.louversOpeningInput) > 0;

        portaInnerHtml = state.roofType === 1 ? (
          `
      <div class="opening_roof_container">
       <div class="canvas_menu__title canvas_menu__title--blade-r">Retract Options:</div>
       <div class="type_interface_retrect-buttons-louvers__options">
       <div class="type_interface_retrect-buttons-louvers__item option ${state.retractOption === 'oneSide' ? 'active' : ''}" data-retract="oneSide">
        <input class="type_interface_retrect-buttons-louvers__input" type="radio" 
               name="retract_option" value="oneSide" ${state.retractOption === 'oneSide' ? 'checked' : ''}>
        <label class="type_interface__retrect-buttons-louvers__label">
            <span class="radio-circle"></span>
            <span class="color-name">From One End Only</span>
        </label>
          </div>
         <div class="type_interface_retrect-buttons-louvers__item option ${state.retractOption === 'twoSides' ? 'active' : ''}" data-retract="twoSides">
        <input class="type_interface_retrect-buttons-louvers__input" type="radio" 
               name="retract_option" value="twoSides" ${state.retractOption === 'twoSides' ? 'checked' : ''}>
        <label class="type_interface__retrect-buttons-louvers__label">
            <span class="radio-circle"></span>
            <span class="color-name">Meet in the Middle</span>
        </label>
        </div>
            </div>
      <div class="portal-container__range" id="louvers-range_wrap">
         ${louversRange}
      </div>
     </div> 
     <div id="blade-block-wrap" class="${isBladeBlocked ? 'blocked-range' : ''}"> 
         <div class="canvas_menu__title canvas_menu__title--blade-rotation">Blade Rotation</div>
         <div class="portal-container__range" id="blade-range_wrap">
             ${bladeRange}
          </div>
      </div>
    `) : (`
      <div class="canvas_menu__title canvas_menu__title--blade-rotation">Blade Rotation</div>
      <div class="portal-container__range" id="blade-range_wrap">
      ${bladeRange}
      </div>
    `)
        break;

      default:
        break;
    }

    const portalContent = $(`
      <div class="portal-container ${state.portalOption === pergolaConst.systemType.slidingGlassDoor ? 'portal-container--wide' : ''}">
        <span class="portal-container__close"></span>
        ${portaInnerHtml}
      </div>
    `);

    const portalContentTitle = portalContent
      .find(`.portal-container__title`)
      .text();

    const activeColorClass = "type_interface_colors-buttons-led__item--active";

    //#region BLADE ROTATION

    function updateBladeBlockedState() {
      const isBladeBlocked = state.roofType === 1 && Number(state.louversOpeningInput) > 0;

      const $bladeRangeInput = portalContent.find('#blade-range_wrap input');

      $bladeRangeInput.prop('disabled', isBladeBlocked);

      portalContent
        .find('#blade-block-wrap')
        .toggleClass('blocked-range', isBladeBlocked);
    };

    const bladeRangeWrap = portalContent.find('#blade-range_wrap');
    if (bladeRangeWrap.length) {
      createHandleRange(true, bladeRangeWrap, "currentRotationZ");
    }

    const louversRangeWrap = portalContent.find('#louvers-range_wrap');
    if (louversRangeWrap.length) {
      createHandleRange(true, louversRangeWrap, "louversOpeningInput");

      updateBladeBlockedState();

      louversRangeWrap.find('.range__input').on('input', function () {
        updateBladeBlockedState();
      });

      if (state.roofType === 1) {
        const louverSound = new Audio('public/sound/door-closing.mp3');
        louverSound.loop = true;
        louverSound.volume = 0.2;

        const $rangeInput = louversRangeWrap.find('.range__input');

        $rangeInput.on('mousedown touchstart', function () {
          const val = parseFloat($(this).val());
          if (val !== 0) {
            louverSound.currentTime = 0;
            louverSound.play().catch(() => {});
          }
        });

        $rangeInput.on('input', function () {
          const val = parseFloat($(this).val());
          if (val !== 0 && louverSound.paused) {
            louverSound.currentTime = 0;
            louverSound.play().catch(() => {});
          } else if (val === 0) {
            louverSound.pause();
            louverSound.currentTime = 0;
          }
        });

        $(document).on('mouseup.louverSound touchend.louverSound', function () {
          louverSound.pause();
          louverSound.currentTime = 0;
        });
      }
    }

    // retract option handlers:
    $(document).on('click', '.type_interface_retrect-buttons-louvers__item', function (e) {
      e.preventDefault();

      // Update radio state
      $('.type_interface_retrect-buttons-louvers__item').removeClass('active');
      $('.type_interface_retrect-buttons-louvers__input').prop('checked', false);
      $(this).addClass('active');
      $(this).find('.type_interface_retrect-buttons-louvers__input').prop('checked', true);

      const retractValue = $(this).find('input').val();

      if (retractValue === 'oneSide') {
        state.retractOption = 'oneSide';
      } else {
        state.retractOption = 'twoSides';
      }

      pergola.switchFrame();
      pergola.update();
    });

    //#endregion

    //#region MOOD LIGHT
    if ("Mood Light" === portalContentTitle) {
      const mesh = GetGroup("base").children[1];

      //#region INIT INPUT
      portalContent
        .find(".type_interface_colors-buttons-led__item")
        .each(function () {
          const backgroundColor = pergola.rgbToHex(
            $(this)
              .closest(".type_interface_colors-buttons-led__item")
              .find(".image-container")
              .css("background-color")
          );

          if (state.colorLed === backgroundColor) {
            $(this)
              .closest(".type_interface_colors-buttons-led__item")
              .addClass(activeColorClass);
            $(this).prop("checked", true);
          }
        });
      //#endregion

      //#region HANDLE INPUTS
      portalContent
        .find(".type_interface_colors-buttons-led__item")
        .on("click", function () {
          const backgroundColor = pergola.rgbToHex(
            $(this)
              .closest(".type_interface_colors-buttons-led__item") // оновлений селектор
              .find(".image-container")
              .css("background-color")
          );

          state.colorLed = backgroundColor;

          // Додаємо активний клас
          $(this)
            .closest(".type_interface_colors-buttons-led__item") // оновлений селектор
            .addClass(activeColorClass);

          // Видаляємо активний клас у всіх інших елементах
          $(this)
            .closest(".type_interface_colors-buttons-led") // оновлений селектор
            .find(".type_interface_colors-buttons-led__item") // оновлений селектор
            .not($(this).closest(".type_interface_colors-buttons-led__item")) // оновлений селектор
            .removeClass(activeColorClass);

          // Зміна емісії кольору в mesh
          if (mesh && mesh.material) {
            mesh.material.emissive.set(state.colorLed);

            mesh.children.forEach((child) => {
              if (child.material) {
                child.material.emissive.set(state.colorLed);
              }
            });
          }
        });
      //#endregion

      //#region REMOVE BUTTON
      removeHandle(portalContent, portalContentTitle, "moodLight", 1, 7);
      //#endregion

      //#region HANDLE COLOR PICKER
      let pickr;

      portalContent.find("#color-box").css("background-color", state.colorLed);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorLed,

            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorLed = selectedColor;

            if (mesh && mesh.material) {
              mesh.material.emissive.set(state.colorLed);

              mesh.children.forEach((child) => {
                if (child.material) {
                  child.material.emissive.set(state.colorLed);
                }
              });
            }

            portalContent
              .find("#color-box")
              .css("background-color", state.colorLed);

            deleteActiveClassFromContainerRadioType(
              portalContent,
              ".type_interface_colors-buttons-led__item",
              activeColorClass
            );

            pergola.update();
          });
        }

        pickr.show();
      });

      // #endregion
    }
    //#endregion

    //#region LED LIGHT
    if ("LED Lights" === portalContentTitle) {
      //#region INIT INPUT
      portalContent.find(".radio__container__item").each(function () {
        const louverGap = +$(this).find(".radio__container__item__text").text();

        if (state.recessedLighting === louverGap) {
          $(this).closest(".radio__container__item").addClass("active");
        }
      });
      //#endregion

      //#region HANDLE INPUTS
      portalContent.find(".radio__container__item").on("click", function () {
        const louverGap = +$(this).find(".radio__container__item__text").text();

        state.recessedLighting = louverGap;

        portalContent.find(".radio__container__item").each(function () {
          $(this).removeClass("active");
        });

        $(this).addClass("active");

        pergola.update();
      });
      //#endregion

      //#region REMOVE BUTTON

      removeHandle(portalContent, portalContentTitle, "ledLights", 0, 6);
      //#endregion

      //#region HANDLE COLOR PICKER
      let pickr;

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorLed,

            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorLed = selectedColor;

            if (mesh && mesh.material) {
              mesh.material.emissive.set(state.colorLed);

              mesh.children.forEach((child) => {
                if (child.material) {
                  child.material.emissive.set(state.colorLed);
                }
              });
            }

            deleteActiveClassFromContainerRadioType(
              portalContent,
              ".type_interface_colors-buttons-led__item",
              activeColorClass
            );
          });
        }

        pickr.show();
      });

      // #endregion
    }
    //#endregion

    //#region ZIP-SHADE
    if (pergolaConst.systemNameString.autoShade === portalContentTitle) {
      createHandleRange(true, portalContent, "zipInput");

      //#region COLOR PICKER
      let pickr;
      portalContent.find("#color-box").css("background-color", state.colorZip);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorZip,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorZip = selectedColor;
            portalContent.find("#color-box").css("background-color", selectedColor);
            portalContent.find(".portal-container__description span:last-child").text(selectedColor);
            pergola.update();
          });
        }
        pickr.show();
      });
      //#endregion

      //#region REMOVE BUTTON
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        4,
        pergolaConst.systemType.autoShade
      );

      //#endregion
    }
    //#endregion

    //#region SLIDING GLASS DOOR
    if (pergolaConst.systemNameString.slidingGlassDoor === portalContentTitle) {
      if (state.width === 1 || state.length === 1) {
        const clampMax = 25;
        portalContent.find('.range__input').attr('max', clampMax);
        if (state.slidingDoorInput > clampMax) {
          state.slidingDoorInput = clampMax;
          portalContent.find('.range__input').val(clampMax);
        }
      }
      createHandleRange(true, portalContent, "slidingDoorInput");

      //#region COLOR PICKER
      let pickr;
      portalContent.find("#color-box").css("background-color", state.colorSladditec);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorSladditec,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorSladditec = selectedColor;
            portalContent.find("#color-box").css("background-color", selectedColor);
            portalContent.find(".portal-container__description span:last-child").text(selectedColor);
            pergola.update();
          });
        }
        pickr.show();
      });
      //#endregion

      //#region REMOVE BUTTON
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        0,
        pergolaConst.systemType.slidingGlassDoor
      );
      //#endregion
    }

    //#endregion

    //#endregion

    //#region SLIDING-SHATTERS
    if (pergolaConst.systemNameString.privacyWall === portalContentTitle) {
      if (state.width === 1 || state.length === 1) {
        const clampMax = 25;
        portalContent.find('.range__input').attr('max', clampMax);
        if (state.slidingShuttersInput > clampMax) {
          state.slidingShuttersInput = clampMax;
          portalContent.find('.range__input').val(clampMax);
        }
      }
      createHandleRange(true, portalContent, "slidingShuttersInput");

      //#region COLOR PICKER
      let pickr;
      portalContent.find("#color-box").css("background-color", state.colorShutters);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorShutters,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorShutters = selectedColor;
            portalContent.find("#color-box").css("background-color", selectedColor);
            portalContent.find(".portal-container__description span:last-child").text(selectedColor);
            pergola.update();
          });
        }
        pickr.show();
      });
      //#endregion

      //#region REMOVE BUTTON
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        0,
        pergolaConst.systemType.privacyWall
      );
      //#endregion
    }

    //#endregion

    //#region FIX SHATTERS
    if (pergolaConst.systemNameString.fix_shutters === portalContentTitle) {
      //ROTATE
      createHandleRange(
        true,
        portalContent,
        "slidingFixShuttersRotate",
        ".range__input"
      );

      //REMOVE
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        3,
        pergolaConst.systemType.fix_shutters
      );
    }
    //#endregion


    //#enregion

    mainContent.append(portalContent);

    return portalContent;
  }

  const icons = $(`
    <div class="icon_wrap">
    <div class="left_button"></div>

    <div class="icon_container">

        <div class="sun__icon heaters__icon" id="6" data-value="LED Lights">
          <span class="sun__icon__img" id="heaters-n" style="
              background-image: url(public/img/icons/led_light_icon.svg);
          "></span>
       </div>

       <div class="sun__icon shades__icon" id="${pergolaConst.systemType.autoShade}" data-value="${pergolaConst.systemNameString.autoShade}">
          <span class="sun__icon__img" id="shades-n" style="
              background-image: url(public/img/icons/marevo-menu-blinds.svg);
          "></span>
       </div>

        <div class="sun__icon" id="${pergolaConst.systemType.slidingGlassDoor}" data-value="Sliding Glass Door">
          <span class="sun__icon__img" id="light-n" style="
              background-image: url(public/img/icons/marevo-menu-door-sliding-glass.svg);
          "></span>
       </div>

       <div class="sun__icon screen__icon" id="${pergolaConst.systemType.privacyWall}" data-value="${pergolaConst.systemNameString.privacyWall}">
          <span class="sun__icon__img" id="screen-n" style="
              background-image: url(public/img/icons/marevo-menu-shutters-sliding.svg);
              background-position: center;
          "></span>
       </div>

       <div class="sun__icon blade__icon" id="10" data-value="Blade Rotation">
          <span class="sun__icon__img" id="heaters-n" style="
              background-image: url(public/img/icons/marevo-menu-roof-settings.svg);
          "></span>
       </div>
    </div> 

    <div class="right_button"></div>
    </div>
    `);

  modelId.append(icons);

  function scrollLogic() {
    const $iconContainer = $(".icon_container");
    const $leftButton = $(".left_button");
    const $rightButton = $(".right_button");

    function updateButtonVisibility() {
      $(".icon_container").removeClass("icon_container-mobile");

      if ($iconContainer.scrollLeft() === 0) {
        $leftButton.hide();
      } else {
        $leftButton.show();
        $(".icon_container").addClass("icon_container-mobile");
      }

      if (
        $iconContainer.scrollLeft() + $iconContainer.innerWidth() >=
        $iconContainer[0].scrollWidth - 1
      ) {
        $rightButton.hide();
      } else {
        $rightButton.show();
        $(".icon_container").addClass("icon_container-mobile");
      }
    }

    updateButtonVisibility();

    $leftButton.on("click", function () {
      $iconContainer.animate(
        { scrollLeft: "-=50" },
        100,
        updateButtonVisibility
      );
    });

    $rightButton.on("click", function () {
      $iconContainer.animate(
        { scrollLeft: "+=50" },
        100,
        updateButtonVisibility
      );
    });

    $iconContainer.on("scroll", updateButtonVisibility);
  }

  const activeClassNight = "night-mode";
  const activeClassDay = "day-mode";
  const daySwitch = modelId.find("#daySwitch");
  const nightSwitch = modelId.find("#nightSwitch");
  const toggleTime = modelId.find("#js-toggleDayNight");
  const icon = icons.find(".sun__icon");
  const portalLight = mainContent.find(".portal-light");

  const sunIcon = icons.find("#light");

  //#region INIT TIME SCENE
  if (state.dayMode) {
    toggleTime.removeClass("switch--hight");
    daySwitch.prop("checked", true);
    daySwitch.closest("label").addClass(activeClassDay);
    nightSwitch.closest("label").removeClass(activeClassNight);
    $("body").removeClass("night-mode").addClass("day-mode");

    modelId.find("#switchButton-time").removeClass("switchButton-active");

    changeSceneTime("Day");
  } else {
    toggleTime.addClass("switch--hight");
    nightSwitch.prop("checked", true);
    nightSwitch.closest("label").addClass(activeClassNight);
    daySwitch.closest("label").removeClass(activeClassDay);
    $("body").removeClass("day-mode").addClass("night-mode");

    modelId.find("#switchButton-time").addClass("switchButton-active");

    changeSceneTime("Night");
  }
  //#endregion

  //#region HANDLE TIME SCENE
  modelId.find("#switchButton-time").on("click", function () {
    state.dayMode = !state.dayMode;

    $(this).toggleClass("switchButton-active");
    // const isDay = daySwitch.is(":checked");

    if (state.dayMode) {
      toggleTime.removeClass("switch--hight");
      daySwitch.closest("label").addClass(activeClassDay);
      nightSwitch.closest("label").removeClass(activeClassNight);
      $("body").removeClass("night-mode").addClass("day-mode");

      changeSceneTime("Day");
    } else {
      toggleTime.addClass("switch--hight");
      nightSwitch.closest("label").addClass(activeClassNight);
      daySwitch.closest("label").removeClass(activeClassDay);
      $("body").removeClass("day-mode").addClass("night-mode");

      changeSceneTime("Night");
    }
  });
  //#endregion

  //#region ICON LOGIC
  // INIT POP-UP
  setTimeout(() => {
    icon.each(function () {
      const id = $(this).attr("id");
      const activeClass = `sun__icon-active--${id}`;

      if ($(this).hasClass(activeClass)) {
        $(this).trigger("click");
        return false;
      }
    });
  }, 500);

  icon.each(function () {
    const id = $(this).attr("id");

    $(this).on("click", function () {
      const alreadyActive = $(this).hasClass(`sun__icon-active--${id}`);

      icon.each(function () {
        $(this).removeClass(function (index, className) {
          return (className.match(/sun__icon-active--\S+/g) || []).join(" ");
        });
      });

      if (alreadyActive) {
        mainContent.find(".portal-container").remove();
        $(".interface-container").removeClass("interface-container-portal");
        pergola.update();
        return;
      }

      state.portalOption = +id;

      //blade rotation
      if (+id !== 10 && +id !== 7 && +id !== 6) {
        state.currentActiveSystems = +id;
      } else {
        state.currentActiveSystems = null;
      }

      $(this).toggleClass(`sun__icon-active--${id}`);

      const portal = portalGenerete();

      const iconOffset = $(this).offset();

      $(".interface-container").addClass("interface-container-portal");

      const interfaceHeight = $(".interface-container").outerHeight();

      if ($(window).width() <= 1024) {
        portal.css({
          top: "",
          left: "",
        });
      } else {
        const iconOffset = $(this).offset();
        portal.css({
          top: iconOffset.top + $(this).outerHeight() - 30,
          left: iconOffset.left,
          bottom: "",
        });
      }

      pergola.update();
    });
  });

  //#region CLOSE PORTAL
  $(document).on("click", ".portal-container__close", function () {
    $(".interface-container").removeClass("interface-container-portal");
    state.currentActiveSystems = null;

    const existingPortal = mainContent.find(".portal-container");

    if (existingPortal.length > 0) {
      existingPortal.remove();
    }

    icon.each(function () {
      $(this).removeClass(function (index, className) {
        return (className.match(/sun__icon-active--\S+/g) || []).join(" ");
      });
    });

    pergola.update();
  });

  // #endregion
  //#endregion

  //light range
  const customRange = generateRangeHTML(lightRange[0]);
  const customRangeShades = generateRangeHTML(shadesRange[0]);
  const rangeContainer = mainContent.find(".portal-light__range");
  const rangeContainerShades = mainContent.find(".portal-shades__range");
  const iconBlade = icons.find("#10");

  rangeContainer.append(customRange);
  rangeContainerShades.append(customRangeShades);

  // iconBlade.trigger("click");
  icon.hide();

  //DEFAULT BLADE POP UP
  setTimeout(() => {
    showIcon(10, false);
  }, 4000);

  scrollLogic();

  $(window).on("resize", function () {
    $(".icon_container").trigger("scroll");

    icon.each(function () {
      const id = $(this).attr("id");
      const activeClass = `sun__icon-active--${id}`;

      if ($(this).hasClass(activeClass)) {
        $(this).trigger("click");
        return false;
      }
    });
  });

  return { portal: portalLight, sunIcon };
}
